let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bxPBn")).then(() => parcelRequire('gaTij'));